import { api } from "./client";

export type MeSettings = {
  aiCoreIdea: string;
  aiMode: "preview" | "auto";
  followupTemplate: string;
  caseTrigger: string;
};

export function getMeSettings(): Promise<MeSettings> {
  return api(`/me/settings`);
}

export function updateMeSettings(patch: Partial<MeSettings>): Promise<MeSettings> {
  return api(`/me/settings`, { method: "PATCH", body: patch });
}
